import { engineComponent } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { FrameTimerEventEmitter, CreateFrameTimer, FrameTimerEvents } from "../../Utils/FrameTimer";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { UserControls } from "../Common/UserControls/UserControls";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { GameManager } from "../../Managers/GameManager";
import { GameData } from "../Common/Datas/GameData";
import { GameActions } from "../Common/Actions/GameActions";
import { AppContext } from "../../../Common/AppContext";
import { ModuleManager } from "../../Managers/ModuleManager";
import { DataManager } from "../../Managers/DataManager";
import { LimitDialog } from "../Common/Dialogs/LimitDialog";
import { BonusActions } from "../Common/Actions/BonusActions";
import { FreeRoundBonus } from "../Common/Bonuses/FreeRoundBonus";
import { BonusController } from "../../GameComponents/Bonus/BonusController";
import { CustomUtils } from "../../Utils/CustomUtils";
import { PlayList } from "../../Components/Sounds/PlayList";

var GameModules = Communication.Game.GameModules;
var WinType = Communication.Game.WinType;

@engineComponent(ComponentTypes.HtmlElement)
export class DesktopBonusUserControls extends UserControls {
    protected _controller: BonusController;

    private _userControls: HTMLElement;
    private _userControls_supreme: HTMLElement;
    private _afterWinDelay: FrameTimerEventEmitter;
    private _autoplayDelay: FrameTimerEventEmitter;

    private _playButtonDelay: FrameTimerEventEmitter;
    private _backButtonDelay: FrameTimerEventEmitter;

    private _wasCalclulated: boolean = true;
	private _machineStopped: boolean = true;

    private _counter: HTMLElement;
    private _counterDelay: FrameTimerEventEmitter;
    private _counterDiff: number;

    private spinBitmask: number; // bit map mask of respin

    constructor() {
        super("bonus");

        this.spinBitmask = 0b11111;
    }

    create(node: Element): void {
        super.create(node);

        this.registerActions();

        this._afterWinDelay = CreateFrameTimer("afterWinDelay");
        this._afterWinDelay.on(FrameTimerEvents.Complete, this.prepareNewGameRound.bind(this));

        this._autoplayDelay = CreateFrameTimer("autoplayDelay");
        this._autoplayDelay.on(FrameTimerEvents.Complete, this.autoplayDelayed.bind(this));

        this._playButtonDelay = CreateFrameTimer("_playButtonDelay");
        this._playButtonDelay.on(
            FrameTimerEvents.Complete,
            function () {
                this.actions.changeActionState(BonusActions.ActionStart, true);
                HtmlController.updateActionElements(this.getAllActions());
            }.bind(this),
        );

        this._backButtonDelay = CreateFrameTimer("_backButtonDelay");
        this._backButtonDelay.on(
            FrameTimerEvents.Complete,
            function () {
                this.actions.changeActionState(BonusActions.ActionBack, true);
                HtmlController.updateActionElements(this.getAllActions());
            }.bind(this),
        );

        this._counterDelay = CreateFrameTimer("counterDelay");
        this._counterDelay.on(FrameTimerEvents.Complete, this.updateCounter.bind(this));

        this._userControls = document.getElementById("bonusUserControls");
        this._counter = document.getElementById("bonusCounter");
    }

    addController(controller: BonusController): void {
        this._controller = controller;
        this._controller.on(BonusController.StartReceived, this.startReceived.bind(this));
        this._controller.on(BonusController.SpinReceived, this.spinReceived.bind(this));
        this._controller.on(BonusController.RespinReceived, this.respinReceived.bind(this));
        this._controller.on(BonusController.EndReceived, this.endReceived.bind(this));
        this._controller.on(BonusController.MachineStopped, this.machineStopped.bind(this));
        this._controller.on(BonusController.WinCalculationFinished, this.winCalculationFinished.bind(this));
        this._controller.on(BonusController.WinAnimatorTotalStart, this.winAnimatorTotalStart.bind(this));
        this._controller.on(BonusController.AllWinsFinished, this.allWinsFinished.bind(this));
        this._controller.on(BonusController.IntroFinished, this.introFinished.bind(this));
        this._controller.on(BonusController.OutroFinished, this.outroFinished.bind(this));
    }

    registerActions(): void {
        this.actions.registerActions({
            [BonusActions.ActionStart]: false,
            [BonusActions.ActionBack]: false,
            [BonusActions.ActionAutoplay]: false,
            [BonusActions.ActionAutoplayStop]: false,
            [BonusActions.ActionSpin]: false,
            [BonusActions.ActionSpinStop]: false,
            [BonusActions.ActionSkipWin]: false,
        });
    }

    initReceived(): void {
        this._userControls_supreme = document.getElementById("userControls_supreme");

        super.initReceived();

        this._controller.initReceived();

        if (this._userControls != null) {
            this._userControls.style.display = "none";
        }
        if (this._userControls != null && !this._userControls.classList.contains(HtmlController.DisabledClass)) {
            this._userControls.classList.add(HtmlController.DisabledClass);
        }
    }

    restoreGameRound(): void {
        this.prepareNewGameRound();
    }

    startReceived(): void {
        ModuleManager.outroModule(GameModules.Base);
    }

    spinReceived(): void {
        if (DataManager.quickspinEnabled()) {
            this.actions.changeActionState(BonusActions.ActionSpinStop, false);
            HtmlController.updateActionElements(this.getAllActions());
            HtmlController.dispatchUiAction("");
            this._controller.stop();
        } else {
            this.actions.changeActionState(
                BonusActions.ActionSpinStop,
                AppContext.gameConfiguration.GameEnableReelsStop,
            );
            HtmlController.updateActionElements(this.getAllActions());
        }
    }

    respinReceived(): void {
        if (DataManager.quickspinEnabled()) {
            this.actions.changeActionState(BonusActions.ActionSpinStop, false);
            HtmlController.updateActionElements(this.getAllActions());
            DataManager.updateDataElement(GameData.DataRoundId);
            HtmlController.dispatchUiAction("");
            this._controller.stop();
        } else {
            this.actions.changeActionState(
                BonusActions.ActionSpinStop,
                AppContext.gameConfiguration.GameEnableReelsStop,
            );
            HtmlController.updateActionElements(this.getAllActions());
            DataManager.updateDataElement(GameData.DataRoundId);
        }
    }

    endReceived(): void {
        ModuleManager.outroModule(GameModules.BonusRespins);
    }

    dispatchAction(action: string): void {
        if (action === GameActions.ActionSpinOrStop) {
            if (this.actions.getActionState(BonusActions.ActionStart)) {
                action = BonusActions.ActionStart;
            } else if (this.actions.getActionState(BonusActions.ActionBack)) {
                action = BonusActions.ActionBack;
            } else if (this.actions.getActionState(BonusActions.ActionSpin)) {
                action = BonusActions.ActionSpin;
            } else if (this.actions.getActionState(BonusActions.ActionSpinStop)) {
                action = BonusActions.ActionSpinStop;
            } else {
                return;
            }
        }

        if (this.actions.getActionState(action)) {
            super.dispatchAction(action);

            switch (action) {
                case BonusActions.ActionStart:
                    this.start();
                    break;
                case BonusActions.ActionBack:
                    this.back();
                    break;
                case BonusActions.ActionSpin:
                    this.spin();
                    break;
                case BonusActions.ActionSpinStop:
                    this.stop();
                    break;
                case BonusActions.ActionSkipWin:
                    this.skipWin();
                    break;
                case BonusActions.ActionAutoplay:
                    this.autoplay();
                    break;
                case BonusActions.ActionAutoplayStop:
                    this.autoplayStop();
                    break;
            }
        }
    }

    start(): void {
        this.actions.disableAllActions();
        HtmlController.updateActionElements(this.getAllActions());
        this._controller.start();
    }

    spin(): void {
        this._machineStopped = false;
        //we have only respins
        this.respin();
    }

    respin(): void {
        DataManager.Collectable = false;
        ModuleManager.disableGamble();
        this.actions.disableAllActions();

        if (this._counter != null) {
            this._counter.classList.remove("bounce1");
            this._counter.classList.remove("bounce2");
            this._counter.classList.remove("bounce3");
        }

        DataManager.updateGameDataFromModule(
            GameData.DataBonusSpinRemainingCount,
            (GameManager.bonusRespinsResponse.bonusRespins.remainingCount - 1).toString(),
        );
        DataManager.updateDataElement(
            GameData.DataBonusSpinRemainingCount,
            (GameManager.bonusRespinsResponse.bonusRespins.remainingCount - 1).toString(),
        );

        if (DataManager.Autoplay) {
            this.actions.changeActionState(
                BonusActions.ActionAutoplayStop,
                AppContext.gameConfiguration.AutoplayModeEnabled,
            );
        }
        HtmlController.dispatchUiAction("");
        HtmlController.updateActionElements(this.getAllActions());

        DataManager.updateDataElement(GameData.DataTotalWin);

        //if (CustomUtils.isBonusRespin()) {
        //    if (GameManager.bonusRespinsResponse.hasOwnProperty('respin')) {
        //        this.spinBitmask = GameManager.bonusRespinsResponse.respin;
        //    }
        //}

        this.spinBitmask = 0b111111111111111;

        this._controller.respin(this.spinBitmask);

        Platforms.Platforms.spinStarted();
    }

    back(): void {
        this.disable();
        ModuleManager.endBonus();
    }

    stop(): void {
        this.actions.changeActionState(BonusActions.ActionSpinStop, false);
        HtmlController.updateActionElements(this.getAllActions());
        HtmlController.dispatchUiAction("");
        DataManager.quickspinStopped();
        this._controller.stop();
    }

    end(): void {
        if (GameManager.bonusRespinsResponse != null && GameManager.bonusRespinsResponse.totalWin > 0) {
            Platforms.Platforms.win(GameManager.bonusRespinsResponse.totalWin);
        }

        this._controller.end();
    }

    autoplayDelayed(): void {
        this._autoplayDelay.stop();
        if (DataManager.Autoplay) {
            this.autoplay();
        } else {
            this.prepareNewGameRound();
        }
    }

    prepareSkipWin(): void {
        if (
            GameManager.bonusRespinsResponse.currentWin === 0 ||
            !AppContext.gameConfiguration.AutoplaySkipWinAnimationsEnabled
        ) {
            return;
        }

        this.actions.changeActionState(BonusActions.ActionSkipWin, true);
        HtmlController.updateActionElement(BonusActions.ActionSkipWin, true);
    }

    skipWin(): void {
        this.actions.changeActionState(BonusActions.ActionSkipWin, false);
        HtmlController.updateActionElement(BonusActions.ActionSkipWin, false);

        this._autoplayDelay.stop();

        if (DataManager.Autoplay) {
            this.autoplay();
        } else {
            this.spin();
        }
    }

    autoplay(): void {
        this._afterWinDelay.stop();

        if (DataManager.AutoplayPaused) {
            this.actions.changeActionState(
                BonusActions.ActionAutoplayStop,
                AppContext.gameConfiguration.AutoplayModeEnabled,
            );
            HtmlController.updateActionElement(
                BonusActions.ActionAutoplayStop,
                AppContext.gameConfiguration.AutoplayModeEnabled,
            );
            return;
        }

        if (DataManager.AutoplayCount === "∞") {
            DataManager.Autoplay = true;
            DataManager.updateDataElement(GameData.DataAutoplayCount, DataManager.AutoplayCount);
            this.spin();
        } else {
            DataManager.AutoplayCount = (parseInt(DataManager.AutoplayCount) - 1).toString();
            if (parseInt(DataManager.AutoplayCount) >= 0) {
                DataManager.Autoplay = true;
                DataManager.updateDataElement(GameData.DataAutoplayCount, DataManager.AutoplayCount);
                this.spin();
            } else {
                DataManager.Autoplay = false;
                this.prepareNewGameRound();
            }
        }
    }

    autoplayStop(): void {
        DataManager.Autoplay = false;
        this.actions.changeActionState(BonusActions.ActionAutoplayStop, false);
        HtmlController.updateActionElement(BonusActions.ActionAutoplayStop, false);
    }

    machineStopped(): void {
        this._machineStopped = true;
        Platforms.Platforms.spinEnded();

        this._wasCalclulated = GameManager.bonusRespinsResponse.currentWin === 0;

        this.actions.changeActionState(BonusActions.ActionSpinStop, false);

        if (CustomUtils.isBonusRespin()) {
            if (GameManager.bonusRespinsResponse.currentWin === 0) {
                this._counterDiff =
                    GameManager.bonusRespinsResponse.bonusRespins.remainingCount -
                    parseInt(DataManager.getDataById(GameData.DataBonusSpinRemainingCount));
                if (this._counterDiff > 0) {
                    if (this._counter != null) {
                        this._counter.classList.add("bounce" + this._counterDiff);
                    }
                    this.updateCounter();
                } else {
                    this.machineStopFinished();
                }
            }
        }

        if (CustomUtils.isLastBonusSpin(this.limit.bind(this))) {
            this.actions.disableAllActions();
        }

        HtmlController.updateActionElements(this.getAllActions());
    }

    private machineStopFinished(): void {
        this.actions.changeActionState(BonusActions.ActionSpinStop, false);
        this.prepareNewGameRound();

        HtmlController.updateActionElements(this.getAllActions());

        if (GameManager.bonusRespinsResponse.currentWin > 0) {
            this._afterWinDelay.start(30);
        } else {
            this.prepareNewGameRound();
        }

        if (DataManager.Autoplay && GameManager.bonusRespinsResponse.currentWin === 0) {
            this._autoplayDelay.start(15);
        }
    }

    winAnimatorTotalStart(): void {
        this.actions.changeActionState(BonusActions.ActionSpinStop, AppContext.gameConfiguration.GameEnableReelsStop);
        HtmlController.updateActionElements(this.getAllActions());
    }

    winCalculationFinished(): void {
        this._afterWinDelay.stop();

        DataManager.updateDataElement(GameData.DataTotalWin);

        if (CustomUtils.isBonusRespin()) {
            this.disable();
            if (DataManager.Autoplay) {
                this.actions.changeActionState(BonusActions.ActionAutoplayStop, true);
                HtmlController.updateActionElements(this.getAllActions());
            }
            return;
        }

        if (CustomUtils.isLastBonusSpin(this.limit.bind(this))) {
            DataManager.Autoplay = false;
            this.actions.disableAllActions();
            HtmlController.updateActionElements(this.getAllActions());
            return;
        }

        this.prepareNewGameRound();
    }

    allWinsFinished(): void {
        if (GameManager.bonusRespinsResponse != null && GameManager.bonusRespinsResponse.currentWin > 0) {
            Platforms.Platforms.win(GameManager.bonusRespinsResponse.currentWin);
        }

        this._wasCalclulated = true;

        this._afterWinDelay.stop();

        if (CustomUtils.isLastBonusSpin(this.limit.bind(this))) {
            DataManager.Autoplay = false;
            this.actions.disableAllActions();

            this._backButtonDelay.stop();
            this._backButtonDelay.start(90);

            return;
        }

        this.prepareNewGameRound();
    }

    private updateCounter(): void {
        if (this._counterDiff > 0) {
            let remainingCount = parseInt(DataManager.getDataById(GameData.DataBonusSpinRemainingCount));
            remainingCount++;
            DataManager.updateGameDataFromModule(GameData.DataBonusSpinRemainingCount, remainingCount.toString());
            DataManager.updateDataElement(GameData.DataBonusSpinRemainingCount, remainingCount.toString());
            this._counterDiff--;

            PlayList.play("SND_BonusRespinCounter");

            this._counterDelay.start(15);
        } else {
            this._counter.classList.remove("bounce1");
            this._counter.classList.remove("bounce2");
            this._counter.classList.remove("bounce3");
            this.machineStopFinished();
        }
    }

    initIntro(): void {
        FreeRoundBonus.disableUi();
        DataManager.updateGameDataFromModule(
            GameData.DataBonusSpinRemainingCount,
            GameManager.bonusRespinsResponse.bonusRespins.remainingCount.toString(),
        );
        DataManager.updateDataElement(
            GameData.DataBonusSpinRemainingCount,
            GameManager.bonusRespinsResponse.bonusRespins.remainingCount.toString(),
        );

        DataManager.updateDataElement(GameData.DataTotalWin);

        if (this._userControls != null) {
            this._userControls.style.display = "block";
        }
        if (this._userControls_supreme != null) {
            this._userControls_supreme.style.display = "block";
        }

        if (this._userControls != null && this._userControls.classList.contains(HtmlController.DisabledClass)) {
            this._userControls.classList.remove(HtmlController.DisabledClass);
        }
        if (
            this._userControls_supreme != null &&
            this._userControls_supreme.classList.contains(HtmlController.DisabledClass)
        ) {
            this._userControls_supreme.classList.remove(HtmlController.DisabledClass);
        }
        if (this._userControls_supreme != null && !this._userControls_supreme.classList.contains("bonus")) {
            this._userControls_supreme.classList.add("bonus");
        }

        super.initIntro();
        this._controller.initIntro();
        Platforms.Platforms.featureInit({ type: Communication.Game.GameModules.BonusRespins });

        if (CustomUtils.isLastBonusSpin(this.limit.bind(this))) {
            this.actions.disableAllActions();
            this.actions.changeActionState(BonusActions.ActionBack, true);
            HtmlController.updateActionElements(this.getAllActions());
            return;
        }

        this.prepareNewGameRound();
    }

    intro(long: boolean = false, previousModule: string): void {
        FreeRoundBonus.disableUi();
        DataManager.updateGameDataFromModule(
            GameData.DataBonusSpinRemainingCount,
            GameManager.bonusRespinsResponse.bonusRespins.remainingCount.toString(),
        );
        DataManager.updateDataElement(
            GameData.DataBonusSpinRemainingCount,
            GameManager.bonusRespinsResponse.bonusRespins.remainingCount.toString(),
        );

        this._controller.intro(long, previousModule);

        if (this._userControls != null) {
            this._userControls.style.display = "block";
        }

        if (this._userControls_supreme != null) {
            this._userControls_supreme.style.display = "block";
        }

        if (this._userControls_supreme != null && !this._userControls_supreme.classList.contains("bonus")) {
            this._userControls_supreme.classList.add("bonus");
        }
    }

    introFinished(): void {
        this.prepareNewGameRound();
        if (this._userControls != null && this._userControls.classList.contains(HtmlController.DisabledClass)) {
            this._userControls.classList.remove(HtmlController.DisabledClass);
        }

        if (
            this._userControls_supreme != null &&
            this._userControls_supreme.classList.contains(HtmlController.DisabledClass)
        ) {
            this._userControls_supreme.classList.remove(HtmlController.DisabledClass);
        }
    }

    outro(): void {
        DataManager.Autoplay = false;

        this._controller.outro();

        if (this._userControls != null && !this._userControls.classList.contains(HtmlController.DisabledClass)) {
            this._userControls.classList.add(HtmlController.DisabledClass);
        }

        if (
            this._userControls_supreme != null &&
            !this._userControls_supreme.classList.contains(HtmlController.DisabledClass)
        ) {
            this._userControls_supreme.classList.add(HtmlController.DisabledClass);
        }
    }

    outroFinished(): void {
        ModuleManager.introModule(GameModules.Base, true, GameModules.BonusRespins);

        if (this._userControls != null) {
            this._userControls.style.display = "none";
        }
        if (this._userControls_supreme != null && this._userControls_supreme.classList.contains("bonus")) {
            this._userControls_supreme.classList.remove("bonus");
        }
    }

    prepareNewGameRound(): void {
        this._afterWinDelay.stop();

        if (DataManager.GameLimit) {
            DataManager.Autoplay = false;
            this.limit();
        } else {
            if (!DataManager.Autoplay) {
                this.actions.changeActionStates({
                    [BonusActions.ActionStart]: false,
                    [BonusActions.ActionBack]: false,
                    [BonusActions.ActionAutoplay]:
                        !DataManager.Autoplay && AppContext.gameConfiguration.AutoplayModeEnabled,
                    [BonusActions.ActionAutoplayStop]:
                        DataManager.Autoplay && AppContext.gameConfiguration.AutoplayModeEnabled,
                    [BonusActions.ActionSpin]: true,
                    [BonusActions.ActionSpinStop]: false,
                    [BonusActions.ActionSkipWin]: false,
                });
            } else {
                this.prepareSkipWin();
            }
        }

        HtmlController.updateActionElements(this.getAllActions());
    }

    limit(): void {
        LimitDialog.openDialog();

        this.actions.changeActionStates({
            [BonusActions.ActionStart]: false,
            [BonusActions.ActionBack]: false,
            [BonusActions.ActionAutoplay]: false,
            [BonusActions.ActionAutoplayStop]: false,
            [BonusActions.ActionSpin]: false,
            [BonusActions.ActionSpinStop]: false,
            [BonusActions.ActionSkipWin]: false,
        });
    }

    enable(): void {
        DataManager.updateDataElement(
            GameData.DataBonusSpinRemainingCount,
            GameManager.bonusRespinsResponse.bonusRespins.remainingCount.toString(),
        );
        DataManager.updateDataElement(
            GameData.DataBonusSpinCount,
            GameManager.bonusRespinsResponse.bonusRespins.totalCount.toString(),
        );

        // this.actions.changeActionState(BonusActions.ActionStart, true);
        // HtmlController.updateActionElements(this.getAllActions());
        this._playButtonDelay.stop();
        this._playButtonDelay.start(30);

        this._controller.enable();
    }

    restoreActions() {
        super.restoreActions();

        if (
            DataManager.Autoplay &&
            this._machineStopped &&
            this.actions.getActionState(BonusActions.ActionAutoplayStop)
        ) {
            this._autoplayDelay.stop();
            this._autoplayDelay.start(30);
        }
    }

    disable(): void {
        this.actions.disableAllActions();
        HtmlController.updateActionElements(this.getAllActions());
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Desktop/DesktopBonusUserControls.ts
 **/